import * as types from '@/store/mutations'
import api from '@/services/returns'

const state = {
    optionsMap:null,
    claims:[],
    returns:[]
}

const getters = {
    optionsMap: (state) => state.optionsMap,
    claims: (state) => state.claims,
    returnReasons: (state) => {
      if(state.optionsMap !== null) {
            //console.log(state.optionsMap.primaryObject.reasons)
            return state.optionsMap.primaryObject.reasons
        }else{
            return []
        }

    },
    returnStatuses: (state) => {
        if(state.optionsMap !== null) {
            return state.optionsMap.primaryObject.status
        }else{
            return []
        }
    },
    returnConclusions: (state) => {
        if(state.optionsMap !== null) {
            //console.log(state.optionsMap.primaryObject)
            return state.optionsMap.primaryObject.conclusions
        }else{
            return []
        }
    }

}

const actions = {
    loadOptionsMap({ commit } ) {
        return new Promise((resolve, reject) => {
            api.optionsMap().then( res => {
                if(res){
                    commit(types.SET_MAP, res)
                    resolve(res)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },
    loadClaims({ commit } ) {
        return new Promise((resolve, reject) => {
            api.claims().then( res => {
                if(res){
                    commit(types.SET_CLAIMS, res)
                    resolve(res)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },
    loadAdminPendingClaims({ commit } ) {
        return new Promise((resolve, reject) => {
            api.adminPendingClaims().then( res => {
                if(res){
                    commit(types.SET_ADMIN_PENDING_CLAIMS, res)
                    resolve(res)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },
    loadAdminAllClaims({ commit } ) {
        return new Promise((resolve, reject) => {
            api.adminAllClaims().then( res => {
                if(res){
                    commit(types.SET_CLAIMS, res)
                    resolve(res)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },

    addClaimComment(context, payload){

        return new Promise((resolve, reject) => {
            //console.log('loadClaim happening with payload:',payload)
            api.addClaimComment(payload).then( res => {
                if(res){
                    resolve(res)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },

    loadClaim(context, payload ) {
      return new Promise((resolve, reject) => {
        //console.log('loadClaim happening with payload:',payload)
            api.loadClaim(payload).then( res => {
                if(res){
                    resolve(res)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },
    verifyReturnViability(context, payload ) {
        return new Promise((resolve, reject) => {
            api.verifyReturnViability(payload.lineId).then( res => {
                if(res){
                    resolve(res.primaryObject)
                }
            }).catch((e) => {
                reject(e)
            })
        })
    },
    uploadMoneyBack(context, payload ) {
        return new Promise((resolve, reject) => {
            api.uploadMoneyBack(payload).then( res => {

                resolve(res)

            }).catch((e) => {
                reject(e)
            })
        })
    },

  uploadErrorImage(context, payload ) {
    return new Promise((resolve, reject) => {
      //console.log("Store: about to call api for media upload:",payload);
      api.uploadErrorImage(payload).then( res => {
        resolve(res)
      }).catch((e) => {
        reject(e)
      })
    })
  },
  adminUpdateClaim(context, payload){
    return new Promise((resolve, reject) => {
      api.adminUpdateClaim(payload).then( res => {
        resolve(res)
      }).catch((e) => {
        reject(e)
      })
    })
  },
  markClaimAsRead(context, payload){
        return new Promise((resolve, reject) => {
            api.markClaimAsRead(payload).then( res => {
                resolve(res)
            }).catch((e) => {
                reject(e)
            })
        })
    },
    generateReturnShipment(context, payload){
        return new Promise((resolve, reject) => {
            api.generateReturnShipment(payload).then( res => {
                resolve(res)
            }).catch((e) => {
                reject(e)
            })
        })

    },

    makeClaim(context, payload){
        let claimObject = {
            webOrderLine: payload.webOrderLine,
            quantity: payload.quantity,
            claimReason:payload.returnReason
        }
        //console.log(payload.reasonMap.requiresReferenceSKU);

        if(payload.reasonMap.requiresErrorDescription === 1){
            claimObject['errorDescription'] = payload.errorDescription.description
            //console.log("store:returns:makeClaim Set mediaid, errorDesc and claimReason for make claim service call:",claimObject);
        }

        if(payload.reasonMap.requiresImageUpload === 1){
            claimObject['mediaid'] = payload.imageReference
            //console.log("store:returns:makeClaim Set mediaid, errorDesc and claimReason for make claim service call:",claimObject);
        }
        if(payload.reasonMap.requiresReferenceSKU === 1){
            claimObject['referenceSKU'] = payload.referenceSKU.sku
          //console.log("store:returns:makeClaim Set mediaid, errorDesc and claimReason for make claim service call:",claimObject);
        }
        if(payload.reasonMap.requiresReplacementSKU === 1){
            claimObject['replacementSKU'] = payload.replacementSKU.sku
            //console.log("store:returns:makeClaim Set mediaid, errorDesc and claimReason for make claim service call:",claimObject);
        }
        if(payload.reasonMap.requiresUploadedMoneyBackForm === 1){
            claimObject['mediaid'] = payload.mediaId
            //console.log("store:returns:makeClaim Set mediaid, errorDesc and claimReason for make claim service call:",claimObject);
        }

        return new Promise((resolve,reject)=>{
           api.makeClaim(claimObject).then(res=>{
                resolve(res)
            }).catch((e)=>{
                reject(e)
            })
        })
    }
}

const mutations = {
  [types.SET_MAP](state, map){
    state.optionsMap = map
  },
  [types.SET_CLAIMS](state, claims){
    state.claims = claims
  },
  [types.SET_ADMIN_PENDING_CLAIMS](state, claims){
    state.claims = claims
  }

}


export default {
    state,
    getters,
    actions,
    mutations
}
